module.exports = __webpack_public_path__ + "img/help.6b6a4433.svg";